import { Link as LinkComponent } from '@cheqroom/ui';

import useNavigation from '../../hooks/navigation/use-navigation.hook';

const Link: typeof LinkComponent = ({ children, external, url, ...rest }) => {
	const navigation = useNavigation();
	const relativeURLRegex = new RegExp('^(?!www.|(?:http)s?://|[A-Za-z]:\\|//)[^/]*/[^/].*$', 'i');
	const isRelative = external ? false : relativeURLRegex.test(url ?? '');

	return (
		<LinkComponent
			{...rest}
			external={external}
			url={url}
			onClick={(e) => {
				// Always stop propagation
				e.stopPropagation();

				rest.onClick?.(e);

				if (!isRelative) return;

				// Don't override default browser behaviour if the user is interacting with the link using a modifier key
				if (e.shiftKey || e.metaKey || e.ctrlKey || e.altKey) {
					return;
				}

				// Override default browser behaviour when navigating normally within the application (using our own router)
				e.preventDefault();
				url && navigation.navigate(url);
			}}
		>
			{children}
		</LinkComponent>
	);
};

export default Link;
